import {/* loadTableExport, loadTablesMetadata,*/ getAppsReadyToMigrate, assignAppsForUsers, executeQuery, actAs, resetMe, syncChatUserRoles } from '../services/adminApi';
import { useMsal } from '@azure/msal-react';

export const Admin: React.FC = () => {
    const { instance } = useMsal();
    return (
    <div>
        {/*<input type="button" value="Get export (only for admin)" onClick={() => loadTableExport(instance, document.getElementById('tableName')['value'])} />*/}
        <input id="tableName" type="text" /><br/>
       {/* <input type="button" value="Get metadata (only for admin)" onClick={() => loadTablesMetadata(instance)} /><br/>*/}
        <input type="button" value="Get apps ready to migrate (only for admin)" onClick={() => getAppsReadyToMigrate(instance)} /><br />
        <input type="button" value="Assign random apps for users (comma separated)" onClick={() => assignAppsForUsers(instance, document.getElementById('usersEmails')['value'])} />
        <input id="usersEmails" type="text" /><br />
        <input type="button" value="Execute" onClick={() => executeQuery(instance, document.getElementById('queryTxt')['value'])} />
        <input id="queryTxt" type="text" /><br />
        <input type="button" value="Act As" onClick={() => actAs(instance, document.getElementById('actAsId')['value'])} />
        <input id="actAsId" type="text" /><br />
        <input type="button" value="Reset Me" onClick={() => resetMe(instance)} /><br/>
        <input type="button" value="Sync Chat" onClick={() => syncChatUserRoles(instance, document.getElementById('syncLimit')['value'])} />
        <input id="syncLimit" type="text" /><br />
    </div>
  );
}

export default Admin;